// extracted by mini-css-extract-plugin
export default {"scoresheetTable":"Scoresheet_scoresheetTable__lOvOP"};